import containerFuild from '../html-snippets/container-fuild.js';
import buttonPrimary from '@/views/website/products/components/description/ui-modules/button-primary/raw-html.js';
import css from '../css-snippets/section-manchestore-compare-slider';

const DEFAULT_VIDEO = 'https://cdn.shopify.com/videos/c/o/v/31d1541d9238439dbb5922943bafbb33.mp4';

const defaultFeatures = [
  `<h2 style="text-align:center;"><span style="color:hsl(4,98%,78%);"><i><strong>30s</strong></i></span></h2>
   <p style="text-align:center;"><span style="color:hsl(220,9%,46%);"><strong>Smooth Filing</strong></span></p>
  `,
  `<h2 style="text-align:center;"><span style="color:hsl(4,98%,78%);"><i><strong>360°</strong></i></span></h2>
   <p style="text-align:center;"><span style="color:hsl(220,9%,46%);"><strong>Complete Care</strong></span></p>
  `,
  `<h2 style="text-align:center;"><span style="color:hsl(4,98%,78%);"><i><strong>100%</strong></i></span></h2>
   <p style="text-align:center;"><span style="color:hsl(220,9%,46%);"><strong>Salon Finish</strong></span></p>
  `,
];

const defaultSlides = [
  {
    before: 'https://cdn.skyfastimg.com/images/2026/08/25/image-6a8d1bd445d4dc41300f5bd2.webp?w=1000',
    after: 'https://cdn.skyfastimg.com/images/2026/08/25/image-6a8d1bd802799d9f44543a63.webp?w=1000',
  },
  {
    before: 'https://cdn.skyfastimg.com/images/2026/08/25/image-6a8d1c160773c4f037533fe5.webp?w=1000',
    after: 'https://cdn.skyfastimg.com/images/2026/08/25/image-6a8d1c1ad165ed5d7b6c05b8.webp?w=1000',
  },
  {
    before: 'https://cdn.skyfastimg.com/images/2026/08/25/image-6a8d1c3e103981e613a371be.webp?w=1000',
    after: 'https://cdn.skyfastimg.com/images/2026/08/25/image-6a8d1c425fb32bf4601323a2.webp?w=1000',
  },
];

const renderFeature = content => `
  <div class="mcs__feature" data-attribute="mcs__feature">
    <div class="mcs__feature-content" data-attribute="mcs__feature-content">${content}</div>
  </div>
`;

const renderSlide = (slide, index) => `
  <div class="swiper-slide mcs__slide" data-attribute="mcs__slide">
    <div class="mcs__compare" data-attribute="mcs__compare">
      <img
        class="mcs__compare-image mcs__compare-image--after"
        data-attribute="mcs__after-image"
        src="${slide.after}"
        alt="After result ${index + 1}"
        loading="lazy"
      />
      <div class="mcs__before-layer">
        <img
          class="mcs__compare-image mcs__compare-image--before"
          data-attribute="mcs__before-image"
          src="${slide.before}"
          alt="Before result ${index + 1}"
          loading="lazy"
        />
      </div>
      <button class="mcs__handle" type="button" aria-label="Adjust before and after comparison">
        <span class="mcs__handle-knob" aria-hidden="true">
          <svg viewBox="0 0 18 18" focusable="false">
            <path d="m7 5-4 4 4 4M11 5l4 4-4 4" fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.8" />
          </svg>
        </span>
      </button>
      <span class="mcs__tag mcs__tag--before">Before</span>
      <span class="mcs__tag mcs__tag--after">After</span>
    </div>
  </div>
`;

const buttonHtml = buttonPrimary({
  text: 'Get 50% Off Now',
  backgroundColor: '#FF5900',
  color: '#FFFFFF',
  radius: 999,
  iconPrefix: { show: false, src: '' },
  iconSuffix: {
    show: true,
    src: 'https://cdn.skyfastimg.com/images/2026/06/11/image-6a2a87db55a093b7ad8c6903.png',
  },
  subBtn: { show: false, text: '' },
});

const contentHtml = `
  <div
    class="mcs container"
    data-attribute="manchestore-compare-slider"
    data-media-position="left"
    data-media-type="video"
    data-compare-position="50"
    style="--mcs-compare-position: 50%;"
  >
    <header class="mcs__title" data-attribute="mcs__title">
      <h2 style="text-align:center;"><span style="font-size:36px;"><strong>From Thick Nails to Salon Results</strong></span></h2>
      <p style="text-align:center;"><span style="color:hsl(0, 0%, 30%);">Create smooth, healthy-looking nails with professional precision at home.</span></p>
    </header>

    <div class="mcs__grid">
      <div class="mcs__media-column">
        <div class="mcs__media" data-attribute="mcs__media">
          <video class="mcs__media-element mcs__media-video" data-attribute="mcs__video" autoplay muted loop playsinline>
            <source data-attribute="mcs__video-source" src="${DEFAULT_VIDEO}" type="video/mp4" />
          </video>
          <img class="mcs__media-element mcs__media-image" data-attribute="mcs__image" src="" alt="Manchestore nail care result" loading="lazy" />
        </div>
        <div class="mcs__features" data-attribute="mcs__features">
          ${defaultFeatures.map(renderFeature).join('')}
        </div>
      </div>

      <div class="mcs__compare-column">
        <div class="swiper mcs__swiper">
          <div class="swiper-wrapper" data-attribute="mcs__slides">
            ${defaultSlides.map(renderSlide).join('')}
          </div>
          <button class="swiper-button-prev mcs__navigation mcs__navigation--prev" type="button" aria-label="Previous result"></button>
          <button class="swiper-button-next mcs__navigation mcs__navigation--next" type="button" aria-label="Next result"></button>
        </div>
        <div class="swiper-pagination mcs__pagination"></div>
        <div class="mcs__cta">${buttonHtml}</div>
      </div>
    </div>
  </div>
`;

export default containerFuild(contentHtml, css, {
  backgroundColor: '#FEF0EF',
  textColor: '#000000',
});
